import Modal from "@/common/elements/Modal";
import { useState } from "react";
import CommonReport from "../CommonReport";
import CommonReportActionHeader from "./CommonReportActionHeader";

const CommonReportModal = ({
  show = false,
  onHide,
  size = "xxl",
  reportData = [],
  reportHeader,
  tableInfoFooter,
  tableInfoHeader,
  hideInfoTableHeader,
  hideDefaultTable,
}) => {
  const onHideHandler = () => {
    onHide?.();
  };
  const onGetCurrenRow = (row) => {
    console.log("row: ", row);
  };

  const onCloseHandler = (booleanValue) => {
    onHideHandler();
  };

  return (
    <Modal
      header="BI2 technologies Report"
      show={show}
      size={size}
      onHide={onHideHandler}
      handleCancel={onCloseHandler}
    >
      {/* <div className="report-header">
           {<CommonReportActionHeader onClose={onCloseHandler} />}
        </div> */}

      <CommonReport
        hideDefaultTable={hideDefaultTable}
        tableData={reportData}
        reportHeader={reportHeader}
        hideInfoTableHeader={hideInfoTableHeader}
        tableInfoFooter={tableInfoFooter}
        tableInfoHeader={tableInfoHeader}
        onRowClickFn={onGetCurrenRow}
      />
    </Modal>
  );
};
export default CommonReportModal;
